import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { AppleButtonComponent } from './apple-button/apple-button.component';
import { FacebookButtonComponent } from './facebook-button/facebook-button.component';
import { LoginSignupButtonComponent } from './login-signup-button/login-signup-button.component';

@NgModule({
  imports: [CommonModule, ComponentsModule, TrackingModule, UiModule],
  declarations: [
    AppleButtonComponent,
    FacebookButtonComponent,
    LoginSignupButtonComponent,
  ],
  exports: [
    AppleButtonComponent,
    FacebookButtonComponent,
    LoginSignupButtonComponent,
  ],
})
export class LoginSignupButtonsModule {}
